import { createGlobalStyle } from 'styled-components/macro'

import { placeholderColor, textColor } from './colors'

export const GlobalStyle = createGlobalStyle`
  
@keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
}

@keyframes scrolling-global {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

* {
  box-sizing: border-box;
}

body {
  font-family: 'Metropolis', Helvetica, Arial, sans-serif;
  font-display: optional;
  margin: 0;
  padding: 0;
  background-color: #101010;
  color: ${textColor};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  --collection-margin: 90px;
}

h1 {
  font-size: 40px;
  font-weight: bold;
  display: inline-block;
  margin: 30px auto;
  color: ${textColor};

  @media (max-width: 700px) {   
    font-size: 30px;
    margin: 20px auto;
  }
}

h2 {
  font-size: 20px;
  font-weight: normal;
  display: block;
  margin: 0;
}

h3 {
  font-size: 30px;
  font-weight: normal;
  display: block;
  margin: 0;
}

input {
  color: ${textColor};
  font-size: 14px;
}

::placeholder {
  color: ${placeholderColor};
  font-size: 14px;
}

*:focus {
  outline: none;
}

a {
  color: ${textColor};
  text-decoration: none;
  opacity: 1;
  transition: opacity 0.15s ease-in-out-out;
  will-change: opacity;
}

p {
    font-family: "Metropolis", sans-serif;
    display: block;
    margin-block-start: 10px;
    margin-block-end: 10px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

.gradient-background-animation  {
    background: linear-gradient(100deg, #212125, #212125, #35353b,#212125, #212125);
    background-size: 1000% 1000%;

    -webkit-animation: AnimationName 2s ease infinite;
    -moz-animation: AnimationName 2s ease infinite;
    animation: AnimationName 2s ease infinite;
}

@-webkit-keyframes AnimationName {
    0%{background-position:19% 0%}
    100%{background-position:82% 100%}
}
@-moz-keyframes AnimationName {
    0%{background-position:19% 0%}
    100%{background-position:82% 100%}
}
@keyframes AnimationName {
    0%{background-position:19% 0%}
    100%{background-position:82% 100%}
}

.max-width{
  max-width: 2400px;
  margin: auto;
}
.web3modal-modal-lightbox { z-index: 10 !important; }
`
